<template>
  <div
    v-if="transportsList.length"
    class="transport-number-helpers-box"
  >
      <span
        v-for="(transportItem, index) in transportsList"
        :key="transportItem.number + index"
      >
          <a
            v-if="transport.number !== transportItem.number"
            @click="changeTransport(transportItem)"
            class="transport-number-helpers"
          >
            <span
              v-if="getCountDuplicateNumber(transportsList, transportItem) <= 1
                || transportItem.trailer === ''
                || transportItem.trailer === null"
            >{{ transportItem.number.toUpperCase() }}
            </span>
            <span v-else>
              {{ transportItem.number.toUpperCase() }} ({{ transportItem.trailer.toUpperCase() }})
            </span>
          </a>
          &nbsp;
      </span>
  </div>
</template>

<script>
import transportInputMixin from '@/common/mixins/application-form/transportInputMixin';
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import hasErrorsMixin from '@/common/mixins/hasErrorsMixin';

export default {
  name: 'NumberHelpersInput',

  mixins: [
    applicationInputMixin,
    transportInputMixin,
    hasErrorsMixin
  ],

  props: {
    visitor: {
      default: undefined
    },

    transportPlateMasks: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selectedPlate: null
    };
  },

  computed: {
    transportsList() {
      const transports = this.form.visitors
        .map(visitor => {
          return visitor.transports
            .filter(transport => transport.number !== '' && transport.number !== null)
        })
        .flat(1)

      return transports.reduce((uniqueTransports, currentTransport) => {
        if (this.isDuplicateNumberAndTrailer(uniqueTransports, currentTransport) === false) {
          uniqueTransports.push(currentTransport)
        }

        return uniqueTransports
      }, [])
    }
  },

  methods: {
    changeTransport(transportItem) {
      this.$emit('set-transport', {
        ...transportItem,
        trailer: this.isHisTransport(transportItem) ? '' : transportItem.trailer
      })
    },

    isHisTransport(currentTransport) {
      let hisTransports = this.visitor.transports

      if (hisTransports.length === 0) {
        return false
      }

      return hisTransports.some(transport => {
        return transport.number === currentTransport.number &&
          transport.trailer === currentTransport.trailer
      })
    },

    getCountDuplicateNumber(transports, currentTransport) {
      if (currentTransport === null) {
        return false
      }

      return transports
        .filter(transport => transport.number === currentTransport.number)
        .length
    },

    isDuplicateNumberAndTrailer(transports, currentTransport) {
      return transports.some(transport => {
        return transport.number === currentTransport.number &&
          transport.trailer === currentTransport.trailer
      })
    }
  }
}
</script>
